import { Component, HostListener, Input, OnInit, inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { DefaultComponent } from "src/app/default.component";
import { IconReplacePipe } from "src/pipes/icon-replace.pipe";
import { PrefixTemplate } from "../../PrefixTemplate";

@Component({
  selector: "app-template-html",
  templateUrl: "./template-html.component.html",
  imports: [IconReplacePipe],
  styleUrl: "./template-html.component.less",
})
export class TemplateHTMLComponent<CONTROL, VALUE = CONTROL> extends DefaultComponent implements PrefixTemplate<CONTROL, VALUE>, OnInit {
  @Input({ required: true })
  public control: FormControl<CONTROL> | null;

  @Input({ required: true })
  public value: VALUE | null;

  @Input()
  public label: string | null;

  @Input()
  public showPlaceholderIfEmpty: boolean;

  private router: Router;

  public constructor() {
    super();
    this.router = inject(Router);
    this.control = null;
    this.value = null;
    this.label = null;
    this.showPlaceholderIfEmpty = true;
  }

  public ngOnInit(): void {
    if (!this.control) throw new Error("Undefined control");
  }

  @HostListener("click", ["$event"])
  public onLinkClick(event: PointerEvent): void {
    const element = <HTMLElement>event.target;
    if (element.nodeName === "A") {
      const link = element.getAttribute("href");
      if (link && link.startsWith("/")) {
        event.preventDefault();
        this.router.navigate([link]);
      }
    }
  }
}
